import React, { useEffect, useState } from 'react';
import { Container, ListGroup } from 'reactstrap';
import { buildTree } from '../../../../helpers/tools_helper';
import IitemBranch from '../iItemBranch/IitemBranch';
import IheaderItemsTree from '../../../IheaderItemsTree';

const IitemsTree = ({CommodityList,milestoneConfig,actionOnRowClickTreeView}:any) => {

    const [dataMap,setDataMap] = useState([]);
    const [header,setHeader] = useState<any>([]);



    useEffect(()=>{
        const {rootNodes,headers} = buildTree(CommodityList, milestoneConfig);
        setDataMap(rootNodes);
        setHeader(headers)
        
   },[CommodityList,milestoneConfig])

    return (
        <Container fluid>
            <ListGroup style={{overflowX:"scroll"}}>
                <IheaderItemsTree header={header.map((obj:any) => obj.text)}/>
                    <>
                        {dataMap.map((node: any, index: any) => (
                            <IitemBranch actionOnClick={actionOnRowClickTreeView} headers={header} key={`${node.id}-treeViw${index}`} node={node} />
                        ))}
                    </>
            </ListGroup>
        </Container>
    );
};

export default IitemsTree;
